import { render } from "./AdminTranslationTabs.vue?vue&type=template&id=699a140f"
import script from "./AdminTranslationTabs.vue?vue&type=script&lang=js"
export * from "./AdminTranslationTabs.vue?vue&type=script&lang=js"

import "./AdminTranslationTabs.vue?vue&type=style&index=0&id=699a140f&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__